module.exports = __webpack_public_path__ + "static/media/banani-das.348f322b.jpeg";